'use client';

import { Logo } from '@lichtblick/photon/atoms/logo/logo';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import type { FC, MouseEventHandler } from 'react';

import styles from './footer.module.scss';

interface FooterLink {
  href: string;
  label: string;
  onClick?: MouseEventHandler;
}

const FOOTER_LINKS: FooterLink[] = [
  { label: 'Impressum', href: '/impressum/' },
  { label: 'Datenschutz', href: '/datenschutz/' },
  { label: 'Hinweis geben', href: '/hinweisgebersystem/' },
  {
    label: 'Cookie-Zustimmung',
    href: '#uc-central-modal-show',
    onClick: (event) => {
      event.preventDefault();
      window.__ucCmp?.showSecondLayer();
    },
  },
  { label: 'Kontakt', href: '/kontakt/' },
  { label: 'Rechtliche Hinweise', href: '/rechtliche-hinweise/' },
  { label: 'Vertrag hier kündigen', href: '/vertrag-kuendigen/' },
  { label: 'Veröffentlichungen', href: '/veroeffentlichungen/' },
  { label: 'Marktpartner', href: '/marktpartner/' },
];

export const Footer: FC = () => (
  <footer className={styles.footer}>
    <ul className={styles['link-list']}>
      {FOOTER_LINKS.map(({ href, label, onClick }) => (
        <li className={styles['list-item']} key={href}>
          <TextCTA as="a" className={styles['text-cta']} href={href} onClick={onClick} slim>
            {label}
          </TextCTA>
        </li>
      ))}
    </ul>
    <a className={styles['logo-link']} href="/">
      <Logo />
    </a>
    <p className={styles['copyright-text']}>© {new Date().getFullYear()} LichtBlick</p>
  </footer>
);
